import { createColumnHelper } from '@tanstack/react-table';
import { formatDateDayjs } from 'utilities/date';
import { FORMATPHONENUMBER } from 'utilities/regularexpressions';

const columnHelper = createColumnHelper<SMSLine>();

export const smsTableColumns = [
  columnHelper.accessor('smsLine', {
    header: 'SMS LINE',
    cell(props) {
      return FORMATPHONENUMBER(props.getValue());
    },
  }),
  columnHelper.accessor('assignedTo', { header: 'ASSIGNED TO' }),
  columnHelper.accessor('lineType', { header: 'LINE TYPE' }),
  columnHelper.accessor('lastUpdate', {
    header: 'LAST UPDATE',
    cell(props) {
      return formatDateDayjs(props.getValue(), 'MMM d yyyy');
    },
  }),
  columnHelper.accessor('status', { header: 'STATUS' }),
];
